// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { orderDetailsInfoLayoutStyles } from "@conklin/App/Widgets/Layout/OrderDetailsInfoLayout";
import { xScreen } from "@conklin/XDL/Utilities";
import { css } from "styled-components";

orderDetailsInfoLayoutStyles.container = {
    css: css`
        display: flex;
        flex-wrap: wrap;
        justify-content: start;
        align-items: stretch;
        row-gap: 20px;
        margin-bottom: 24px;
        @media print {
            display: block;
        }
    `,
};
orderDetailsInfoLayoutStyles.wrapper = {
    css: css`
        flex-grow: 0;
        flex-shrink: 1;
        flex-basis: 33%;
        &:has(> div:empty) {
            display: none;
        }

        ${xScreen("lte", "md")} {
            flex-basis: 50%;
        }

        @media print {
            margin-bottom: 12px;
        }
    `,
};
